var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v(_vm._s(_vm.paidInfo.realName)+" 您已付款成功！订单号为"+_vm._s(_vm.paidInfo.orderNo))]),_vm._v(" "),_c('p',[_vm._v("请联系老师进行学习！")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-24dcd2a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/h5/h5OrderInfo.vue
// module id = null
// module chunks = 